import { instance } from "apis/interceptor";
import { IAlarmChannel } from "apis/meeting-room-complain/alarm-channel";
import { TMeetingRoom } from "apis/meetings/meeting-room";
import { TSlackChannel } from "apis/messangers";

import { IReceiverMember } from "pages/meeting/complain-manager-setting/uis/table-view/person-table-view";
import { TMember } from "types/user.types";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

//* INFO: 기기 담당자 리스트 조회ㅣ
export const getDeviceAlarmManagerList = async (): Promise<IReceiverMember[]> => {
  try {
    const res = await instance.get("/meeting-room-device/alarm-receiver");
    return res.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

//* INFO: 기기 담당자 추가
export const addDeviceAlarmManager = async (members: TMember[]): Promise<boolean> => {
  try {
    await instance.post("/meeting-room-device/alarm-receiver", {
      memberList: members,
    });
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

//* INFO: 기기 담당자 삭제
export const deleteDeviceAlarmManager = async (mediumId: string): Promise<boolean> => {
  try {
    const res = await instance.delete("/meeting-room-device/alarm-receiver", {
      data: {
        id: mediumId,
      },
    });
    return res.data.result;
  } catch (error) {
    console.error(error);
    return false;
  }
};

//* INFO: 기기 알람 채널 리스트 조회
export const getDeviceAlarmChannelList = async (): Promise<IAlarmChannel[]> => {
  try {
    const res = await instance.get("/meeting-room-device/alarm-channel/slack");
    return res.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

//* INFO: 기기 알람 채널 추가
export const addDeviceAlarmChannel = async (channel: TSlackChannel): Promise<boolean> => {
  try {
    await instance.post("/meeting-room-device/alarm-channel/slack", channel);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

//* INFO: 기기 알람 채널 삭제
export const deleteDeviceAlarmChannel = async (mediumId: string): Promise<boolean> => {
  try {
    const res = await instance.delete("/meeting-room-device/alarm-channel/slack", {
      data: {
        id: mediumId,
      },
    });
    return res.data.result;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export type TDeviceSummaryStats = {
  totalNum: number;
  normalNum: number;
  abnormalNum: number;
};

//* INFO: 기기 요약 정보 조회
export const getDeviceSummaryStats = async (): Promise<TDeviceSummaryStats> => {
  try {
    const res = await instance.get("/meeting-room-device/summary");
    return res.data;
  } catch (error) {
    console.error(error);
    return {
      totalNum: 0,
      normalNum: 0,
      abnormalNum: 0,
    };
  }
};

export type TMeetingRoomDevice = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deviceId: string;
  isBatteryCharging: boolean;
  batteryLevel: number;
  location: "INSIDE" | "OUTSIDE";
};

export type TExtendedMeetingRoom = TMeetingRoom & {
  meetingRoomDevices: TMeetingRoomDevice[];
};

//* INFO: 회의실 기기 리스트 조회
export const getMeetingRoomDeviceList = async (abnormalOnly: boolean): Promise<TExtendedMeetingRoom[]> => {
  try {
    const res = await instance.post("/meeting-room-device/list", { abnormalOnly });
    return res.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

//* INFO: 회의실 기기 관리 알림 채널 변경
export const changeDeviceAlarmChannel = async (channel: "SLACK" | "EMAIL"): Promise<ResponseType<boolean>> => {
  try {
    const response = await instance.patch(`/meeting-room-device/alarm-receiver/my-alarm-channel`, {
      hostAlarmChannel: channel,
    });
    return { success: response.data.result, message: "설정이 변경되었습니다." };
  } catch (error: any) {
    if (error.response.status === 409) {
      return { success: false, message: "슬랙 메신저가 설정되지 않았습니다." };
    }
    if (error.response.status === 403) {
      return { success: false, message: "회의실 기기 관리 담당자 설정이 되지 않았습니다." };
    } else {
      return { success: false, message: "알림 채널 변경에 실파하였습니다. 다시 시도해주세요." };
    }
  }
};
